<div class="row p-4">
  <div class="col">
    <p class="step-title">Upload Resumes</p>

    <div class="ats-upload-btn d-flex justify-content-center align-items-center" *ngIf="resumeStatus=='upload'">
      <div class="col text-center p-5 ng-star-inserted">
        <div class="col px-0">
          <p class="font-weight-500 f-14 text-bluex mb-1"> Drag and drop or click here to select multiple files</p>
          <p class="f-12 font-weight-normal text-center text-9696 line-height-1 mb-1">Accepted file type: PDF, DOC, DOCX, TXT, ODT<br>
            Max files: 10 | File Size: 5MB </p>
        </div>
      </div>
      <input data-testid="auto-app-bulk-resume-upload-model-input-1" accept=".pdf" type="file" class="ng-star-inserted" multiple="true" (change)="uploadResume($event);">
    </div>

    <div class="bulkparse-upload text-center mb-2 p-5" style="border: 1px dotted #2E93A1; background-color: #ECF0F4;"
      *ngIf="resumeStatus=='ongoing'">

      <p class="mb-1 text-center w-30"><strong>{{totalFilesUploaded}} out of {{fileList.length}}</strong> uploaded</p>

      <ngb-progressbar type="success" class="mb-1" [value]="totalFilesUploaded"
        [max]="fileList.length"></ngb-progressbar>

      <p class="text-center" style="margin-top: 13px;"
        *ngIf="fileList?.length && totalFilesUploaded < fileList?.length">Uploading in process</p>
      <p class="text-center" style="margin-top: 13px;" *ngIf="fileList?.length == totalFilesUploaded">Uploaded
        Successfully</p>

      <!-- <div class="" *ngIf="idx >= fileList.length">
        <p class="mt-2 f-12">
          <i class="fas fa-exclamation-circle" style="color: #f3c04c;"
            *ngIf="totalFilesSucessfullyUploaded < fileList.length"></i>
          <i class="fas fa-check-circle" *ngIf="totalFilesSucessfullyUploaded >= fileList.length"
            style="color: #229300;"></i>
          {{totalFilesSucessfullyUploaded}} out of {{fileList.length}} were successfully uploaded
        </p>
      </div> -->
    </div>

    <p class="text-danger f-14 mt-2" *ngIf="showMaxFileError">
      {{ maxFileErrorMessage }}
    </p>

    <div class="mt-1" *ngIf="(fileInfoList?.length > 0) && (fileInfoList?.length == totalFilesUploaded)">
      <p class="f-14 font-weight-600 m-0">Uploading Status</p>
      <div class="d-flex mt-1">
        <p class="p-0"><i class="fas fa-check-circle" style="color: #229300;"></i> {{totalFilesSucessfullyUploaded}}
          Success | </p>
        <p class="p-0 ml-1"><i class="fas fa-exclamation-circle" style="color: #af2c2c;"></i>
          {{totalunsuccessfullFilesUploaded}}
          Failed | </p>
        <p class="p-0 ml-1"><i class="fas fa-exclamation-circle" style="color: #E58313;"></i>
          {{totalDuplicateFileUploaded}}
          Duplicate</p>
      </div>
    </div>

    <div *ngFor="let file of fileInfoList">
      <div class="d-flex justify-content-between mt-2">
        <div class="d-flex" style="word-break:break-word">
          <div>
            <span *ngIf="file?.status=='success'"><i class="fas fa-check-circle" style="color: #229300;"></i></span>
            <span *ngIf="file?.status=='duplicate'"><i class="fas fa-exclamation-circle"
                style="color: #E58313;"></i></span>
            <span *ngIf="file?.status=='unsuccessful'"><i class="fas fa-exclamation-circle"
                style="color: #af2c2c;"></i></span>
            <span *ngIf="file?.status=='load'">
              <div class="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </span>
          </div>
          <div class="ml-1">
            <p class="mb-0" *ngIf="file.filename.length > 0 && file.candidatename.length==0">{{file.filename}}</p>
          </div>
        </div>
        <div style="text-align: right;">
          <p class="f-14 font-weight-400 m-0" style="color: #969696;"
            *ngIf="file?.message?.length > 0 && (file?.status !== 'success')">{{file.message}}</p>
          <span (click)="deleteResume(file)" class="pointer" *ngIf="file?.status=='success'"><i
              class="fa-sharp fa-solid fa-xmark" style="color: #2E93A1;"></i></span>
        </div>
      </div>
      <hr class="my-3">
    </div>

    <div class="d-flex justify-content-end align-items-center mt-2">
      <p class="m-0 pointer text-webbtree-green mr-2" (click)="dismiss('cancel')">Cancel</p>
      <button data-testid="auto-app-bulk-resume-upload-model-button-1" class="btn-trms-small ml-1"
        [ngClass]="{ 'bg-gray': bulkSpinnerLoader || !addBulkCandidateArray?.length,  'text-center': bulkSpinnerLoader }"
        (click)="addBulkResume()" [disabled]="bulkSpinnerLoader || !addBulkCandidateArray?.length">
        <span [ngClass]="{ 'spinner-border text-blue spinner-size': bulkSpinnerLoader }"
          [ngStyle]="{ 'width: 20px; height: 20px;': bulkSpinnerLoader }">
          {{bulkSpinnerLoader ? '' : 'Add'}}
        </span>
      </button>
    </div>
  </div>
</div>